import Hero from "./homeComponents/Hero";
import Checklist from "./homeComponents/Checklist";
//import Founders from "./homeComponents/Founders";
//import Newsletter from "./homeComponents/Newsletter";
import EarlyAccess from "./homeComponents/EarlyAccess";
import Bar from "./homeComponents/Bar";
// import ContactUs from "./homeComponents/ContactUs";

import React, { useMemo } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import SVGComponent1 from "./homeComponents/SVGComponents/SVGComponent1";
import SVGComponent2 from "./homeComponents/SVGComponents/SVGComponent2";
import SVGComponent3 from "./homeComponents/SVGComponents/SVGComponent3";

function Home() {
  // Memoize SVG strings to prevent re-rendering on every component update
  const svgString1 = useMemo(
    () => encodeURIComponent(renderToStaticMarkup(<SVGComponent1 />)),
    []
  );
  const svgString2 = useMemo(
    () => encodeURIComponent(renderToStaticMarkup(<SVGComponent2 />)),
    []
  );
  const svgString3 = useMemo(
    () => encodeURIComponent(renderToStaticMarkup(<SVGComponent3 />)),
    []
  );

  return (
    <main>
      <div
        className="bg-no-repeat bg-cover bg-gray-900"
        style={{ backgroundImage: `url("data:image/svg+xml,${svgString1}")` }}
      >
        <Hero />
        <Bar />
      </div>
      <div
        className="bg-no-repeat bg-cover bg-gray-900"
        style={{ backgroundImage: `url("data:image/svg+xml,${svgString2}")` }}
      >
        <Checklist />
        {/* <Demo /> */}
      </div>
      <div
        className="bg-no-repeat bg-cover bg-gray-900"
        style={{ backgroundImage: `url("data:image/svg+xml,${svgString3}")` }}
      >
        {/* <Blog /> */}
        {/* <Survey /> */}
        <EarlyAccess />
      </div>
    </main>
  );
}

export default Home;
